import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable, tap } from 'rxjs';

@Injectable()
export class DebugModeInterceptor implements HttpInterceptor {
  private _modalShown = false;

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this._modalShown) return next.handle(req);

    return next.handle(req).pipe(
      tap(event => {
        if (event instanceof HttpResponse && event.headers.get('X-Matwins-Debug-Mode') === 'true') {
          this._modalShown = true;
          // Utiliser un setTimeout pour laisser le rendu Angular se terminer
          setTimeout(() => {
            alert('⚠️ Debug - Development Mode\n\nIdentityServer check is bypassed.\nYou are authenticated as dev-admin.\n\nThis mode CANNOT be used in production.\n\nClick OK to continue.');
          }, 500);
        }
      })
    );
  }
}
